import { api } from 'common';
import { Column } from 'material-table';
import { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { ICancelReasonType } from 'common/src/types';
import { useSelector, useDispatch } from "react-redux";
import { CustomMaterialTable } from 'components/CustomMaterialTable';

export default function CancellationReasons() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { editCancellationReason } = api;
  const [data, setData] = useState<ICancelReasonType[]>([]);
  const settings = useSelector(state => state.settingsdata.settings);
  const cancelreasondata = useSelector(state => state.cancelreasondata);


  const columns: Column<ICancelReasonType>[] = [
    { title: t('reason'), field: 'label', render: rowData => <span>{rowData.label}</span> }
  ];

  useEffect(() => {
    if (cancelreasondata.complex) {
      setData(cancelreasondata.complex);
    } else {
      setData([]);
    }
  }, [cancelreasondata.complex]);

  return (
    <CustomMaterialTable
      columns={columns}
      title={'cancellation_reasons'}
      data={cancelreasondata.complex ?? []}
      editable={settings?.AllowCriticalEditsAdmin ? {
        onRowAdd: newData =>
          new Promise((resolve, reject) => {
            setTimeout(() => {
              const tblData = data;
              newData.value = tblData.length;
              if (!(newData && newData.label)) {
                alert(t('no_details_error'));
                reject();
              } else {
                tblData.push(newData);
                dispatch(editCancellationReason(tblData as any, "Add"));
                resolve("");
              }
            }, 600);
          }),
        onRowUpdate: (newData, oldData) =>
          new Promise((resolve, reject) => {
            setTimeout(() => {
              if (!(newData && newData.label)) {
                alert(t('no_details_error'));
                reject();
              } else {
                resolve("");
                if (newData !== oldData && oldData) {
                  const tblData = data;
                  tblData[tblData.indexOf(oldData)] = newData;
                  dispatch(editCancellationReason(tblData as any, "Update"));
                }
              }
            }, 600);
          }),
        onRowDelete: oldData =>
          new Promise(resolve => {
            setTimeout(() => {
              resolve("");
              const tblData = data;
              const newTtblData = tblData.filter((item) => item.value !== oldData.value);
              dispatch(editCancellationReason(newTtblData as any, "Delete"));
            }, 600);
          }),
      } : undefined}
    />
  );
}
